import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class AuthorizationApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    // First Information

    getFirstInformations(id) {
        return axios.get(`${URL_API}/admin/autorizacao/primeira-informacao/${id}`, this.getConfig())
    }

    updateFirstInformations(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/primeira-informacao/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Legal Guardian

    getLegalGuardian(id) {
        return axios.get(`${URL_API}/admin/autorizacao/responsavel-legal/${id}`, this.getConfig())
    }

    updateLegalGuardian(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/responsavel-legal/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // About Initiative

    getAboutInitiative(id) {
        return axios.get(`${URL_API}/admin/autorizacao/sobre-organizacao/${id}`, this.getConfig())
    }

    updateAboutInitiative(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/sobre-organizacao/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Management Planning

    getManagementPlanning(id) {
        return axios.get(`${URL_API}/admin/autorizacao/planejamento-gestao/${id}`, this.getConfig())
    }

    updateManagementPlanning(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/planejamento-gestao/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Financial Sustainability

    getFinancialSustainability(id) {
        return axios.get(`${URL_API}/admin/autorizacao/sustentabilidade-financeira/${id}`, this.getConfig())
    }

    updateFinancialSustainability(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/sustentabilidade-financeira/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Networks Partners

    getNetworksPartners(id) {
        return axios.get(`${URL_API}/admin/autorizacao/redes-parceiros/${id}`, this.getConfig())
    }

    updateNetworksPartners(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/redes-parceiros/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Results Impacts

    getResultsImpacts(id) {
        return axios.get(`${URL_API}/admin/autorizacao/resultados-impacto/${id}`, this.getConfig())
    }

    updateResultsImpacts(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/resultados-impacto/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Governance

    getGovernance(id) {
        return axios.get(`${URL_API}/admin/autorizacao/governanca/${id}`, this.getConfig())
    }

    updateGovernance(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/governanca/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }

    // Attachments

    getAttachments(id) {
        return axios.get(`${URL_API}/admin/autorizacao/anexos/${id}`, this.getConfig())
    }

    updateAttachments(seq, value, userId) {
        return axios.put(`${URL_API}/admin/autorizacao/anexos/update/${seq}/${value}/${userId}`, {}, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/admin/authorization-api/AuthorizationApi.js